<template>
  <div class="custom-label__input">
    <span class="custom-label__input-text">
      {{ label }}
    </span>
  </div>
</template>

<script setup lang="ts">
/** Displays the text of a preview label with its shared truncation layout. */
defineProps<{ label: string }>()
</script>
